import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import PointRulePage from './pages/PointRulePage';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import AccountsPage from './pages/AccountsPage';
import ABookPage from './pages/ABookPage';
import StatisticsPage from './pages/StatisticsPage';
import RuleStatisticsPage from './pages/RuleStatisticsPage';
import RecommendationPage, {
  ShortHighWinRatePage,
  LongStablePage,
  HighPayoffPage,
  NormalLossPage,
} from './pages/PatternPage';
import RulesPage from './pages/RulesPage';
import AccountDetailPage from './pages/AccountDetailPage';
import ReconciliationPage from './pages/ReconciliationPage';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    setChecking(false);
  }, []);

  if (checking) return <div style={{ background: '#0f0f1a', minHeight: '100vh' }} />;
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<Navigate to="/dashboard" />} />
          <Route path="/dashboard" element={<PrivateRoute><Layout><DashboardPage /></Layout></PrivateRoute>} />
          <Route path="/accounts" element={<PrivateRoute><Layout><AccountsPage /></Layout></PrivateRoute>} />
          <Route path="/a-book" element={<PrivateRoute><Layout><ABookPage /></Layout></PrivateRoute>} />
          <Route path="/rules" element={<PrivateRoute><Layout><RulesPage /></Layout></PrivateRoute>} />
          <Route path="/statistics" element={<Navigate to="/statistics/accounts" />} />
          <Route path="/statistics/accounts" element={<PrivateRoute><Layout><StatisticsPage /></Layout></PrivateRoute>} />
          <Route path="/statistics/rules" element={<PrivateRoute><Layout><RuleStatisticsPage /></Layout></PrivateRoute>} />
          <Route path="/pattern/short-high-winrate" element={<PrivateRoute><Layout><ShortHighWinRatePage /></Layout></PrivateRoute>} />
          <Route path="/pattern/long-stable" element={<PrivateRoute><Layout><LongStablePage /></Layout></PrivateRoute>} />
          <Route path="/pattern/high-payoff" element={<PrivateRoute><Layout><HighPayoffPage /></Layout></PrivateRoute>} />
          <Route path="/pattern/normal-loss" element={<PrivateRoute><Layout><NormalLossPage /></Layout></PrivateRoute>} />
          <Route path="/pattern/recommendation" element={<PrivateRoute><Layout><RecommendationPage /></Layout></PrivateRoute>} />
          <Route path="/pattern/account/:login" element={<PrivateRoute><Layout><AccountDetailPage /></Layout></PrivateRoute>} />
          <Route path="/pattern" element={<Navigate to="/pattern/short-high-winrate" />} />
          <Route path="/point-rule" element={<Navigate to="/point-rule/rules" />} />
          <Route path="/point-rule/rules" element={<PrivateRoute><Layout><PointRulePage /></Layout></PrivateRoute>} />
          <Route path="/point-rule/symbols" element={<PrivateRoute><Layout><PointRulePage /></Layout></PrivateRoute>} />
          <Route path="/point-rule/accounts" element={<PrivateRoute><Layout><PointRulePage /></Layout></PrivateRoute>} />
          <Route path="/point-rule/statistics" element={<PrivateRoute><Layout><PointRulePage /></Layout></PrivateRoute>} />
          <Route path="/point-rule/reconciliation" element={<PrivateRoute><Layout><ReconciliationPage /></Layout></PrivateRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
